import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _22139184 = () => interopDefault(import('../pages/404.vue' /* webpackChunkName: "pages/404" */))
const _0298e28c = () => interopDefault(import('../pages/access-notification.vue' /* webpackChunkName: "pages/access-notification" */))
const _6b287234 = () => interopDefault(import('../pages/access-rights.vue' /* webpackChunkName: "pages/access-rights" */))
const _39ee3856 = () => interopDefault(import('../pages/add-object.vue' /* webpackChunkName: "pages/add-object" */))
const _fa8a17c4 = () => interopDefault(import('../pages/all-pages.vue' /* webpackChunkName: "pages/all-pages" */))
const _2161b8d6 = () => interopDefault(import('../pages/auth/index.vue' /* webpackChunkName: "pages/auth/index" */))
const _794effcc = () => interopDefault(import('../pages/dashboard.vue' /* webpackChunkName: "pages/dashboard" */))
const _40e2da75 = () => interopDefault(import('../pages/Errors.vue' /* webpackChunkName: "pages/Errors" */))
const _62ca20df = () => interopDefault(import('../pages/fast-commands.vue' /* webpackChunkName: "pages/fast-commands" */))
const _3460678e = () => interopDefault(import('../pages/not-found.vue' /* webpackChunkName: "pages/not-found" */))
const _ba77b40c = () => interopDefault(import('../pages/Objects.vue' /* webpackChunkName: "pages/Objects" */))
const _2e9f220c = () => interopDefault(import('../pages/payment.vue' /* webpackChunkName: "pages/payment" */))
const _4bb7511c = () => interopDefault(import('../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _dfbdfe78 = () => interopDefault(import('../pages/schedule/index.vue' /* webpackChunkName: "pages/schedule/index" */))
const _3feaccaf = () => interopDefault(import('../pages/settings-object.vue' /* webpackChunkName: "pages/settings-object" */))
const _f6d47c06 = () => interopDefault(import('../pages/auth/EmailFail.vue' /* webpackChunkName: "pages/auth/EmailFail" */))
const _2719af18 = () => interopDefault(import('../pages/auth/EmailSuccess.vue' /* webpackChunkName: "pages/auth/EmailSuccess" */))
const _17d3ab68 = () => interopDefault(import('../pages/auth/passowordSuccess.vue' /* webpackChunkName: "pages/auth/passowordSuccess" */))
const _0cf59914 = () => interopDefault(import('../pages/auth/PasswordRestoreFail.vue' /* webpackChunkName: "pages/auth/PasswordRestoreFail" */))
const _9bf463e8 = () => interopDefault(import('../pages/auth/restoreAccount.vue' /* webpackChunkName: "pages/auth/restoreAccount" */))
const _398d2043 = () => interopDefault(import('../pages/auth/serviceEngeneer.vue' /* webpackChunkName: "pages/auth/serviceEngeneer" */))
const _7da3d1ae = () => interopDefault(import('../pages/auth/waitconfirm.vue' /* webpackChunkName: "pages/auth/waitconfirm" */))
const _1107943b = () => interopDefault(import('../pages/payments/finish.vue' /* webpackChunkName: "pages/payments/finish" */))
const _69b0e024 = () => interopDefault(import('../pages/payments/select.vue' /* webpackChunkName: "pages/payments/select" */))
const _1ad0dae4 = () => interopDefault(import('../pages/profile/initial.vue' /* webpackChunkName: "pages/profile/initial" */))
const _6177390b = () => interopDefault(import('../pages/payments/orders/canceled.vue' /* webpackChunkName: "pages/payments/orders/canceled" */))
const _3faf5834 = () => interopDefault(import('../pages/payments/orders/created.vue' /* webpackChunkName: "pages/payments/orders/created" */))
const _9c79e0fe = () => interopDefault(import('../pages/payments/orders/success.vue' /* webpackChunkName: "pages/payments/orders/success" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _718f0108 = () => interopDefault(import('../pages/auth/password-create/_token.vue' /* webpackChunkName: "pages/auth/password-create/_token" */))
const _41ad6990 = () => interopDefault(import('../pages/auth/password-restore/_token.vue' /* webpackChunkName: "pages/auth/password-restore/_token" */))
const _13e4a241 = () => interopDefault(import('../pages/payments/orders/_order.vue' /* webpackChunkName: "pages/payments/orders/_order" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _22139184,
    name: "404"
  }, {
    path: "/access-notification",
    component: _0298e28c,
    name: "access-notification"
  }, {
    path: "/access-rights",
    component: _6b287234,
    name: "access-rights"
  }, {
    path: "/add-object",
    component: _39ee3856,
    name: "add-object"
  }, {
    path: "/all-pages",
    component: _fa8a17c4,
    name: "all-pages"
  }, {
    path: "/auth",
    component: _2161b8d6,
    name: "auth"
  }, {
    path: "/dashboard",
    component: _794effcc,
    name: "dashboard"
  }, {
    path: "/Errors",
    component: _40e2da75,
    name: "Errors"
  }, {
    path: "/fast-commands",
    component: _62ca20df,
    name: "fast-commands"
  }, {
    path: "/not-found",
    component: _3460678e,
    name: "not-found"
  }, {
    path: "/Objects",
    component: _ba77b40c,
    name: "Objects"
  }, {
    path: "/payment",
    component: _2e9f220c,
    name: "payment"
  }, {
    path: "/profile",
    component: _4bb7511c,
    name: "profile"
  }, {
    path: "/schedule",
    component: _dfbdfe78,
    name: "schedule"
  }, {
    path: "/settings-object",
    component: _3feaccaf,
    name: "settings-object"
  }, {
    path: "/auth/EmailFail",
    component: _f6d47c06,
    name: "auth-EmailFail"
  }, {
    path: "/auth/EmailSuccess",
    component: _2719af18,
    name: "auth-EmailSuccess"
  }, {
    path: "/auth/passowordSuccess",
    component: _17d3ab68,
    name: "auth-passowordSuccess"
  }, {
    path: "/auth/PasswordRestoreFail",
    component: _0cf59914,
    name: "auth-PasswordRestoreFail"
  }, {
    path: "/auth/restoreAccount",
    component: _9bf463e8,
    name: "auth-restoreAccount"
  }, {
    path: "/auth/serviceEngeneer",
    component: _398d2043,
    name: "auth-serviceEngeneer"
  }, {
    path: "/auth/waitconfirm",
    component: _7da3d1ae,
    name: "auth-waitconfirm"
  }, {
    path: "/payments/finish",
    component: _1107943b,
    name: "payments-finish"
  }, {
    path: "/payments/select",
    component: _69b0e024,
    name: "payments-select"
  }, {
    path: "/profile/initial",
    component: _1ad0dae4,
    name: "profile-initial"
  }, {
    path: "/payments/orders/canceled",
    component: _6177390b,
    name: "payments-orders-canceled"
  }, {
    path: "/payments/orders/created",
    component: _3faf5834,
    name: "payments-orders-created"
  }, {
    path: "/payments/orders/success",
    component: _9c79e0fe,
    name: "payments-orders-success"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index"
  }, {
    path: "/auth/password-create/:token?",
    component: _718f0108,
    name: "auth-password-create-token"
  }, {
    path: "/auth/password-restore/:token?",
    component: _41ad6990,
    name: "auth-password-restore-token"
  }, {
    path: "/payments/orders/:order?",
    component: _13e4a241,
    name: "payments-orders-order"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
